import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { SUPPORTED_LANGUAGES } from "./constants/workerOnboarding";

const localeModules = import.meta.glob("./locales/*/translation.json", {
  eager: true,
});

const translationByFolder = Object.fromEntries(
  Object.entries(localeModules).map(([filePath, mod]) => {
    const folder = filePath.match(/locales\/([^/]+)\//)?.[1];
    return [folder, mod.default];
  })
);

const englishTranslation = translationByFolder.eng;

const resources = Object.fromEntries(
  SUPPORTED_LANGUAGES.map(({ code, localeFolder }) => {
    const translation =
      translationByFolder[localeFolder] ?? englishTranslation;

    if (!translationByFolder[localeFolder] && import.meta.env.DEV) {
      console.warn(
        `[i18n] Missing translation file for locale "${localeFolder}" (code: ${code}). Falling back to English.`
      );
    }

    return [code, { translation }];
  })
);

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "en");
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "en",
    fallbackLng: "en",
    load: "languageOnly",
    supportedLngs: Object.keys(resources),

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
